import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ClientSettingsService } from '@features/client-settings/client-settings.service';

export const currenciesResolver: ResolveFn<void> = () => {
  return inject(ClientSettingsService).setAllCurrencies();
};
